import { Component, OnInit } from '@angular/core';

import { User, ErrCode } from '../../shared/models';
import { LoggerService } from '../../core/logger.service';
import { MultiAdminService } from '../../core/multiadmin.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ValidateTokenOutput } from '../../shared/models/multiadmin.model';


@Component({
    selector: 'sync-user-invite-consent',
    templateUrl: './user-invite-consent.component.html',
    providers: [MultiAdminService]
})
export class UserInviteConsentComponent implements OnInit {

    public confirmcode: string;
    public user: User;
    public errcode: ErrCode;
    public spinner = true;
    public isInviteChecked = false;
    public isInviteValid = false;
    public invitee = '';
    public declineSuccess = false;
    public acceptSuccess = false;
    public isPaid = false;
    public isLegacyToCNC = false;
    private tokenData: ValidateTokenOutput;
    public passwordForm: FormGroup;
    public show2FA: boolean;

    constructor(
        private log: LoggerService,
        private maService: MultiAdminService,
        private fb: FormBuilder,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.passwordForm = this.fb.group({
            email: [{ value: '', disabled: true }, Validators.required],
            password: ['', Validators.required],
            twofacode: ['']
        });
        this.confirmcode = this.route.snapshot.queryParams['c'];
        if (this.confirmcode) {
            this.verifyEmailInvite();
        } else {
            this.errcode = new ErrCode(8103, 'No confirmation code provided');
        }
    }

    public async verifyEmailInvite() {
        try {
            this.tokenData = await this.maService.verifyEmailInvite(this.confirmcode);
            this.isInviteValid = this.tokenData.success ? true : false;
            this.invitee = this.tokenData.currentUserEmail;
            this.isPaid = this.tokenData.isPro;
            this.isLegacyToCNC = this.tokenData.isLegacyToCNC === true ? true : false ;
            this.passwordForm.get('email').setValue(this.tokenData.email);
        } catch (ex) {
            this.log.error(ex);
            this.errcode = ErrCode.fromException(ex);
        }
        this.isInviteChecked = true;
        this.spinner = false;
    }

    public async userReaction(accepted: boolean) {
        this.errcode = null;
        this.spinner = true;
        if (accepted) {
            const pwd = this.passwordForm.get('password').value;
            const twofacode = this.passwordForm.get('twofacode').value;
            const isLegacyToCNC = this.isLegacyToCNC;
            try {
                const result = await this.maService.handleAcceptedInviteConsent(this.tokenData, this.confirmcode, pwd, twofacode, isLegacyToCNC);
                if (result.success) {
                    this.acceptSuccess = true;
                } else {
                    this.isInviteValid = false;
                }
            } catch (ex) {
                if (ex.code === 8022) {
                    this.show2FA = true;
                } else {
                    this.log.error(ex);
                    this.errcode = ErrCode.fromException(ex);
                }
            }
            this.spinner = false;
        } else {
            try {
                const result = await this.maService.handleDeclinedInviteConsent(this.tokenData.user_id);
                if (result.success) {
                    this.declineSuccess = true;
                } else {
                    this.isInviteValid = false;
                }
            } catch (ex) {
                this.log.error(ex);
                this.errcode = ErrCode.fromException(ex);
            }
            this.spinner = false;
        }
    }
}
